import PropTypes from 'prop-types'
import React from 'react'
import logo from '../assets/AIND_logo.png'
import openscope_logo from '../assets/crop_openscope.png'
import "./Header.css";
import { Link, NavLink } from "react-router-dom";

const Header = ({ title}) => {
  return (
    <div className="portal-header">
      <div className="headerbar">
        <header className='header'>
          <Link to="/projects" aria-label="OpenScope projects" className="header-logo-link">
            <img src={openscope_logo} alt="OpenScope" className="header-logo" />
          </Link>
          <h1>{title}</h1>
          <img src={logo} alt="Allen Institute for Neural Dynamics" className="header-logo institute-logo" />
        </header>
      </div>
      <nav className="topnav" aria-label="Main navigation">
        <NavLink to="/about">About</NavLink>
        <NavLink to="/projects">Projects</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </nav>
    </div>
) 
}

Header.defaultProps = {
  title: 'OpenScope Data Portal',
  logo: logo
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired
}

export default Header